import { Component, Inject } from '@angular/core';
import { CommsService } from '../../services/comms.service';
import * as Twilio from 'twilio-video';
import { Router } from '@angular/router';
import { SessionInfoVM } from '../models/SessionInfoVM';

//declare const Twilio: any;
declare global {
  interface Window { stream: any; }
}

@Component({
  selector: 'mb-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss']
})
export class AudioComponent {
  video: any;
  activeRoom: any;
  previewTracks: any;
  identity: any;
  roomName: any;
  room: any;

  isMuted: boolean = false;
  session: SessionInfoVM;
  token: string;
  isOtherUserConnected: boolean = false;

  constructor(private commsService: CommsService, private router: Router) {
    this.session = commsService.activeSessionInfo;
  }

  ngOnInit(): void {
    //refer lib
    this.video = Twilio;

    //ME - create the viewing users video tracks before the other guy connects
    var localTracksPromise = this.previewTracks
      ? Promise.resolve(this.previewTracks)
      : this.video.createLocalAudioTrack();

    let self = this;
    localTracksPromise.then(
      (track: any) => {
        self.previewTracks = self.previewTracks = track;
        let previewContainer = document.getElementById('me-audio') as HTMLDivElement;
        if (!previewContainer.querySelector('audio')) {
          self.attachTrack(track, previewContainer);
        }

        //Get video access token using custom Comms Service
        self.commsService.video().subscribe(
          r => {
            self.token = r;             //Cache access token locally            
            self.connectAudioSession(); //Connect to video room to communicate
          }
        );
      },
      (error: any) => {
        console.error('Unable to access local media', error);
      }
    );
  }

  connectAudioSession() {
    this.video.connect(this.token,
      {
        name: this.commsService.activeSessionInfo.id,
        preferredAudioCodecs: ['isac', 'opus'],
        preferredVideoCodecs: ['H264'],
        video: false,
        audio: true
      }).then((room: any) => {

        this.room = room;
        console.log('Connected to Room "%s"', room.name);

        let self = this;

        room.on('trackSubscribed', track => {
          console.log('Participant "%s" connected', track.identity);
          self.isOtherUserConnected = true;
          const div = document.getElementById("you-audio");
          if (track.kind == "audio") {
            div.appendChild(track.attach());
          }
        });

        room.on('participantDisconnected', (participant: any) => {
          console.log('Participant "%s" disconnected', participant.identity);
          self.isOtherUserConnected = false;

          let audioContainer = document.getElementById('you-audio') as HTMLDivElement;
          while (audioContainer.firstChild) {
            audioContainer.removeChild(audioContainer.firstChild);
          }
        });

      });
  }

  //Attach the tracks to the DOM
  attachTrack(track: any, container: any) {
    if (track.kind == "audio") {
      container.appendChild(track.attach());
    }
  }

  // Detach the Tracks from the DOM.
  detachTracks(track: any) {
    let self = this;
    track.mediaStreamTrack.stop();
    track.detach().forEach(function (detachedElement: any) {
      detachedElement.remove();
      self.previewTracks = null;
    });
  }

  // Detach the Participant's Tracks from the DOM.
  detachParticipantTracks(participant: any) {
    var tracks = Array.from(participant.tracks.values());
    this.detachTracks(tracks);
  }

  toggleMute() {
    if (this.isMuted) {
      this.isMuted = false;
      this.room.localParticipant.audioTracks.forEach(
        publication => publication.track.enable()
      );
    }
    else {
      this.isMuted = true;
      this.room.localParticipant.audioTracks.forEach(
        publication => publication.track.disable()
      );
    }
  }

  endSession() {
    localStorage.removeItem('sessionToken');
    try {
      if (this.previewTracks && this.previewTracks.mediaStreamTrack) { 
        this.previewTracks.mediaStreamTrack.stop(); 
      }
      this.room.localParticipant.tracks.forEach(function (publication) {
        publication.track.stop()
        publication.track.detach().forEach((element: any) => element && element.remove());
        publication.unpublish();
      });
      this.previewTracks = null;
      this.room.disconnect();
      this.room = null;
    } catch (e) {
      console.log('Error: ', e);
    }
    this.router.navigateByUrl('/');
  }

}
